// DatabaseShipsPage.jsx
import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import ShipForm from './ShipForm';

const DatabaseShipsPage = () => {
  const [ships, setShips] = useState([]);
  const [message, setMessage] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedShip, setSelectedShip] = useState(null);

  useEffect(() => {
    fetchShips();
  }, []);

  const fetchShips = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/ships`);
      if (res.ok) {
        const data = await res.json();
        setShips(data);
      } else {
        setMessage('Failed to fetch ships.');
      }
    } catch (error) {
      console.error('Error fetching ships:', error);
      setMessage('An error occurred while fetching ships.');
    }
  };

  const deleteShip = async (id) => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/ships/${id}`, {
        method: 'DELETE',
      });
      if (res.ok) {
        setShips(ships.filter((ship) => ship._id !== id));
      } else {
        console.error('Failed to delete ship');
      }
    } catch (error) {
      console.error('Error deleting ship:', error);
    }
  };

  const openEditModal = async (shipId) => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/ships/${shipId}`);
      if (res.ok) {
        const data = await res.json();
        setSelectedShip(data);
        setShowModal(true);
      } else {
        setMessage('Failed to fetch ship data for editing.');
      }
    } catch (error) {
      console.error('Error fetching ship for edit:', error);
      setMessage('An error occurred while fetching ship data.');
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedShip(null);
  };

  const handleUpdateShip = async (updatedData) => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/ships/${selectedShip._id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updatedData),
      });
      if (res.ok) {
        setMessage('Ship updated successfully!');
        fetchShips(); // Refresh the ships list
        closeModal();
      } else {
        setMessage('Failed to update ship.');
      }
    } catch (error) {
      console.error('Error updating ship:', error);
      setMessage('An error occurred while updating the ship.');
    }
  };

  return (
    <div className="container">
      <h2>Ships Database</h2>
      {message && <div className="alert alert-info">{message}</div>}

      <table className="table table-striped">
        <thead>
          <tr>
            <th>Vessel Name</th>
            <th>IMO Number</th>
            <th>Call Sign</th>
            <th>Vessel Type</th>
            <th>Email</th>
            <th>DWT</th>
            <th>DWT-Design</th>
            <th>EEDI</th>
            <th>Built Year</th>
            <th>Flag</th>
            <th>LOA</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {ships.map((ship) => (
            <tr
              key={ship._id}
              onClick={(e) => {
                if (e.target.tagName !== 'BUTTON') openEditModal(ship._id);
              }}
              style={{ cursor: 'pointer' }}
            >
              <td>{ship.vesselName}</td>
              <td>{ship.imoNumber}</td>
              <td>{ship.callSign}</td>
              <td>{ship.vesselType}</td>
              <td>{ship.email}</td>
              <td>{ship.dwt ?? '-'}</td>
              <td>{ship.dwtDesign ?? '-'}</td>
              <td>{ship.eedi ?? '-'}</td>
              <td>{ship.builtYear ?? '-'}</td>
              <td>{ship.flag}</td>
              <td>{ship.loa ?? '-'}</td>
              <td className="text-center">
                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  onClick={(e) => {
                    e.stopPropagation();
                    deleteShip(ship._id);
                  }}
                  title="Delete Ship"
                >
                  X
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Edit Ship Modal */}
      {showModal && selectedShip && (
        <div
          className="modal show fade"
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Ship</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body">
                <ShipForm
                  initialShipData={selectedShip}
                  onSubmit={handleUpdateShip}
                  isEditMode={true}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DatabaseShipsPage;
